const UpdateForm = () => {
  const a = 'a';
  return (
    <div>
      {a}
    </div>
  );
};

export default UpdateForm;
